import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";

import ShyftPassClassListPage from "@/containers/ShyftPassClassListPage";

import { useAppDispatch, useAppSelector } from "@/hooks";
import { appendHotJarScript, renderMetaData, getCanonicalURL } from "@/utils";

//Redux
import * as actions from "@/redux/ShyftPassReducer";
import { wrapper } from "@/redux/Store";

const ShyftPassClassList = ({ classData }) => {
  const dispatch = useAppDispatch();

  const router = useRouter();
  const { slug } = router.query;

  const { classListError } = useAppSelector((state) => state.shyftPass) || {};

  //FOR HOTJAR TRACKING
  useEffect(() => {
    const isProduction = process.env.NEXT_PUBLIC_SENTRY_ENV === "production";
    const { head, script } = appendHotJarScript(isProduction);

    return () => {
      if (isProduction && head && script) head.removeChild(script);
    };
  }, []);

  const getShyftPassScheduleByClassSlug = useCallback(() => {
    dispatch(actions.getShyftPassScheduleByClassSlug({ slug }));
  }, [slug, dispatch]);

  useEffect(() => {
    getShyftPassScheduleByClassSlug();
  }, [getShyftPassScheduleByClassSlug]);

  const metaData = {
    siteName: "Shyftpass",
    siteURL: getCanonicalURL(),
    title:
      classData?.title ||
      "Shyft Pass - Weekend Workouts, Community Mixers, Latest Wellness Products",
    description:
      classData?.description ||
      "Shyft Pass | The best health and wellness membership that provides exclusive access to weekend workouts, community mixers, latest wellness products",
    thumbnail:
      classData?.share_meta_image ||
      "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-11/shyftpass_meta_image-8fd0ae1bf8fa4c3db2bd4d9e7ba64a81.jpg",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main id="shyftpass-individual-class-page">
        <ShyftPassClassListPage h1Tag={classData?.h1_heading} />
      </main>
    </>
  );
};

export default ShyftPassClassList;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      const res = await store.dispatch(
        actions.getShyftPassScheduleByClassSlug({ slug: query.slug })
      );
      const classData = res?.payload?.data || null;
      return { props: { classData } };
    }
);
